import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const HotIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M10.4 1.6001C10.1878 1.6001 9.98434 1.68438 9.83431 1.83441C9.68429 1.98444 9.6 2.18792 9.6 2.4001C9.6 6.4457 4 9.6001 4 15.2001C4 19.4544 8.6108 22.2048 10.2344 22.3829C10.2888 22.3944 10.3443 22.4001 10.4 22.4001C10.6122 22.4001 10.8157 22.3158 10.9657 22.1658C11.1157 22.0158 11.2 21.8123 11.2 21.6001C11.1999 21.4813 11.1734 21.3639 11.1223 21.2566C11.0712 21.1493 10.9969 21.0548 10.9047 20.9798V20.9782C10.1767 20.3878 8.8 18.675 8.8 17.111C8.8 14.5438 11.2 13.6001 11.2 13.6001C9.8312 17.4721 14.3163 17.9399 15.2188 21.7735H15.2203C15.2597 21.951 15.3584 22.1098 15.5002 22.2237C15.6419 22.3376 15.8182 22.3998 16 22.4001C16.1685 22.3997 16.3325 22.3461 16.4688 22.247C16.4832 22.2365 16.4972 22.2256 16.5109 22.2142C16.6411 22.1296 20 19.9081 20 15.2001C20 13.278 19.0387 9.9765 18.3469 8.51416L18.3453 8.50947L18.3438 8.50635C18.2848 8.35711 18.1824 8.22904 18.0498 8.13876C17.9172 8.04848 17.7604 8.00017 17.6 8.0001C17.4132 8.00027 17.2323 8.06584 17.0887 8.18542C16.9452 8.305 16.848 8.47106 16.8141 8.65478V8.65791C16.8121 8.66665 16.4447 10.2985 15.2 11.2001C15.2 7.43079 12.4787 3.53739 11.0438 1.92666C11.0222 1.89749 10.9987 1.86983 10.9734 1.84385C10.899 1.76693 10.8099 1.70572 10.7114 1.66385C10.6129 1.62198 10.507 1.6003 10.4 1.6001Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(HotIcon)
